import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {APIUrl} from './constants';
import {ImagesServiceUrl} from './constants';

@Injectable({
  providedIn: 'root'
})
export class ManagementServiceService {

  readonly APIUrl = APIUrl;
  readonly ImagesServiceUrl = ImagesServiceUrl;

  constructor(private http:HttpClient) { }

  AddUpdateIndustryProductSearchResult(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/SearchIndustryProducts/Add/Update/Industry/Product/SearchResult', val)
  }

  // SearchIndustryProducts(val:any):Observable<any[]>{
  //   return this.http.post<any>(this.APIUrl + '/api/SearchIndustryProducts/Search/Industry/Products', val)
  // }

  ExportIndustryProductsStockValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Export/Industry/Products/Stock/Values', val)
  }

  DeleteIndustryProductListPriceOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Delete/Industry/Product/List/Price/Offer', val)
  }

  DeleteIndustryProductStockOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Delete/Industry/Product/Stock/Offer', val)
  }

  DeleteListPriceOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Delete/List/Price/Offers', val)
  }

  DeleteStockOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Delete/Stock/Offers', val)
  }
  
  AddUpdateListPriceOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Add/Update/List/Price/Offer', val)
  }

  GetImportConfigurationByWarehouse(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Import/Configuration/By/Warehouse', val)
  }

  InitializeNewStockEntry(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Initialize/New/Stock/Entry', val)
  }

  GetIndustryProductsStocksFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Products/Stocks/Filtered/COUNT', val)
  }

  GetIndustryProductsListPriceFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Products/ListPrice/Filtered', val)
  }

  GetIndustryProductsListPriceFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Products/ListPrice/Filtered/COUNT', val)
  }

  GetIndustryProductsStocksFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Products/Stocks/Filtered', val)
  }

  GetIndustryProductByID(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Product/By/ID', val)
  }

  GetIndustryProductListPriceOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Product/List/Price/Offers', val)
  }

  GetIndustryProductStockOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Product/Stock/Offers', val)
  }

  GetIndustryProductsMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Products/MasterData', val)
  }

  InitializeNewIndustryProduct(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Initialize/New/Industry/Product', val)
  }

  UpdateGroupDiscountsData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Update/Group/Discounts/Data', val)
  }

  DeleteImportConfigurationDiscountGroups(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Delete/Import/Configuration/Discount/Groups', val)
  }

  DeleteImportConfigurationOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Delete/Import/Configuration/Offers', val)
  }

  ResetIndustryProductsSearchResultsVersion2(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Reset/Industry/Products/Search/Results/Version2', val)
  }

  ResetIndustryProductsSearchResults(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Reset/Industry/Products/Search/Results', val)
  }

  GetBrandsFilteredWithSuggestion(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Brands/Filtered/With/Suggestion', val)
  }
  
  GetIndustryProductsListPriceOffersCleaningCount(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Products/List/Price/Offers/Cleaning/Count', val)
  }

  CleanIndustryProductsDataOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Clean/Industry/Products/Data/Offers', val)
  }

  UpdateConfigurationPricesAndMOQ(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Update/Configuration/Prices/And/MOQ', val)
  }

  CleanIndustryProductsDupplicateValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Clean/Industry/Products/Dupplicate/Values', val)
  }

  ImportIndustryProductsToMongo(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Import/Industry/Products/To/Mongo', val)
  }

  ImportIndustryProductsToElastic(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Import/Industry/Products/To/Elastic', val)
  }

  ImportIndustryProductsLiteDB(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Import/Industry/Products/Lite/DB', val)
  }

  GetConfigurationOffersCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Configuration/Offers/COUNT', val)
  }

  SearchIndustryProducts(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Search/Industry/Products', val)
  }

  GetBrandsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Brands/Filtered', val)
  }

  AddUpdateBrandLogo(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Add/Update/Brand/Logo', val)
  }

  DeleteBrandLogo(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Delete/Brand/Logo', val)
  }

  AddIndustryProudct(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Add/Industry/Proudct', val)
  }

  GetIndustryProductsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Products/Filtered', val)
  }

  UpdateIndustryProduct(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Update/Industry/Product', val)
  }

  DeleteIndustryProduct(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Delete/Industry/Product', val)
  }

  GetImportConfigurations(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Import/Configurations', val)
  }

  InitializeNewConfiguration(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Initialize/New/Configuration', val)
  }

  GetImportConfigurationPositions(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Import/Configuration/Positions', val)
  }

  GetImportConfigurationDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Import/Configuration/Details', val)
  }

  AddUpdateImportConfiguration(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Add/Update/Import/Configuration', val)
  }

  GetProductsFromConfiguration(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Products/From/Configuration', val)
  }

  GetProductsOfferingData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Products/Offering/Data', val)
  }

  GetProfitSettingsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Profit/Settings/Filtered', val)
  }

  GetProfitSettingsFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Profit/Settings/Filtered/COUNT', val)
  }

  CreateShippingLabel(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Create/Shipping/Label', val)
  }

  PrintShippingLabel(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Print/Shipping/Label', val)
  }

  DeleteShippingLabel(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Delete/Shipping/Label', val)
  }

  RequestPickup(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Request/Pickup', val)
  }

  TrackShippingLabel(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Track/Shipping/Label', val)
  }

  SimulateShippingCost(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Simulate/Shipping/Cost', val)
  }

  GetShippingMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/Shipping/Master/Data', val)
  }

  SearchTracking(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Search/Tracking', val)
  }

  SelectPartnerForNewShipment(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Select/Partner/For/New/Shipment', val)
  }

  GetShippingCompanyServiceTypes(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/Shipping/Company/Service/Types', val)
  }

  InitializeSenderReceiver(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Initialize/Sender/Receiver', val)
  }

  SelectShippingAddressFromUI(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Select/Shipping/Address/FromUI', val)
  }

  GetShippingDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/Shipping/Details', val)
  }

  GetShipmentsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/Shipments/Filtered', val)
  }

  TrackShippingLabelsBulk(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Track/Shipping/Labels/Bulk', val)
  }

  CompareShippingCosts(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Compare/Shipping/Costs', val)
  }

  GetShippingDimentionsHistory(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/Shipping/Dimentions/History', val)
  }

  GetCountryShippingOptions(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/Country/Shipping/Options', val)
  }

  ForceShipmentClose(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Force/Shipment/Close', val)
  }

  UpdateShippingDetailsTrackingStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Update/Shipping/Details/Tracking/Status', val)
  }

  SelectPartnerForNewOrder(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Orders/Select/Partner/For/New/Order', val)
  }

  ChangeOrderStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Orders/Change/Order/Status', val)
  }

  SendContactSupportEmail(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Send/Contact/Support/Email', val)
  }
}
